export default __webpack_public_path__ + "static/media/Search.60723a5c.svg";